import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterTyreService {

  constructor(
    private readonly http: HttpClient
  ) { }

  saveTyreDetails(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/tyres';
    return this.http.post(url, payload);
  }

  getTyreDetails(pagination?:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/tyres/company';
    return this.http.get(url,{ params: pagination });
  }

  getTyreDetailsForAdmin(pagination?:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/tyres';
    return this.http.get(url,{ params: pagination });
  }

  getTyreSearchDeatils(searchTerm?:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/tyres';
    return this.http.get(url,{ params: searchTerm });
  }
  getTyreDetailsByTyreId(tyreId:string): Observable<any>{
    let url = environment.BASE_URL + `/v1/tyres/company/${tyreId}`;
    return this.http.get(url);
  }
  getAdminTyreDetailsByTyreId(tyreId:string): Observable<any>{
    let url = environment.BASE_URL + `/v1/tyres/${tyreId}`;
    return this.http.get(url);
  }

  updateTyreDetails(tyreId:string,payload:any): Observable<any>{
    let url = environment.BASE_URL + `/v1/tyres/company/${tyreId}`;
    return this.http.put(url,payload);
  }
  updateAdminTyreDetails(tyreId:string,payload:any): Observable<any>{
    let url = environment.BASE_URL + `/v1/tyres/${tyreId}`;
    return this.http.put(url,payload);
  }
}
